import { PropertyService } from '@clooper/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'propertyTypeAsync',
    pure: false
})
export class PropertyTypeAsyncPipe implements PipeTransform {
    private cachedPropertyTypes: any = null;
    constructor(private propertyService: PropertyService) {}

  transform(propertyTypeId: string ): string { 
    let  propertyTypeName = null;
    if (!this.cachedPropertyTypes) {
      this.propertyService.getPropertiesTypes(true).subscribe(res => {
        this.cachedPropertyTypes = res;
        propertyTypeName = res[propertyTypeId];
      });
    }
    propertyTypeName = this.cachedPropertyTypes ? this.cachedPropertyTypes[propertyTypeId] : null;
    return propertyTypeName;
  }

}